import { useAuth } from "@clerk/clerk-react";
import { useMediaQuery, useTheme } from "@mui/material";
import { DiscoverViewContext } from "contexts/DiscoverView";
import { OrganizationUserContext } from "contexts/Organization";
import { useContext, useEffect } from "react";

import { fetcherAuth } from "utils/api";

import { ASSISTANT_AUTO_INTRO_SOURCE } from "./api";

const AutoIntroOpener = () => {
  const { getToken } = useAuth();
  const { currentOrg } = useContext(OrganizationUserContext);
  const { discoverTab, openAssistant, assistantAutoIntroAttempted } =
    useContext(DiscoverViewContext);
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("lg"));

  useEffect(() => {
    if (!isLargeScreen || !currentOrg?.id) return;
    if (discoverTab !== null) return;
    if (assistantAutoIntroAttempted.current) return;
    assistantAutoIntroAttempted.current = true;

    let cancelled = false;
    (async () => {
      try {
        const { conversation } = await fetcherAuth(
          getToken,
          `/api/organization/${currentOrg.id}/assistant/conversations`,
          "POST",
        );
        if (cancelled || !conversation) return;
        if (!conversation.has_active_plan || conversation.has_user_messaged) {
          return;
        }
        openAssistant({
          promptPage: "home",
          source: ASSISTANT_AUTO_INTRO_SOURCE,
        });
      } catch {
        // ignore — never block the home page
      }
    })();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentOrg?.id, isLargeScreen, discoverTab]);

  return null;
};

export default AutoIntroOpener;
